define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/ClientUtil',
	'state/UIState',
	'service/UIStateManager',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/ScanQRCodeView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/ScanQRCodeState_strings'
], function (
	Util,
	UiUtil,
	ClientUtil,
	UIState,
	UIStateManager,
	ProviderInfoView,
	NavigationView,
	ScanQRCodeView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * ScanQRCodeState class
	 */
	function ScanQRCodeState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_scanQRCodeView = new ScanQRCodeView(scanCallback),
			_controlBarView = new ControlBarView();

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.scan_qr_code);

		_controlBarView.addButton(CommonStrings.back, function () {
			_uiStateManager.back();
		}, 0);

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});

		UIState.call(this, 'scan_qr_code');


		// private methods

		function scanCallback(transferURL) {
			if (Util.isSameHost(transferURL)) {
				_scanQRCodeView.disableScan();

				_uiStateManager.change('identity_transfer', {
					transferURL : decodeURIComponent(Util.parseParameters(transferURL)['trans']),
					salt : Util.parseParameters(transferURL)['salt']
				});
			}
		}


		// public methods

		this.title = function () {
			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _scanQRCodeView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback) {
			_providerInfoView.update(_uiStateManager.core().cloudIdentitiesManager().providerInfo());

			_scanQRCodeView.update();

			Util.callCallbacks(doneCallback);

			UiUtil.scrollTo(_navigationView.get());
		};

		this.leave = function (doneCallback) {
			_scanQRCodeView.disableScan();

			Util.callCallbacks(doneCallback);
		};
	}

	ScanQRCodeState.prototype = Object.create(UIState.prototype);

	return ScanQRCodeState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/ScanQRCodeState.js
// module id = 348
// module chunks = 2